import {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
} from "react"

const TextAreaInput = forwardRef(({ title, validator, disabled, data, placeholder, errorText }, ref) => {

    const [value, setValue] = useState(data || "")
    const [error, setError] = useState("")

    useEffect(() => {
        if (!data) {
            return
        }
        setValue(data)
    }, [data])

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const isValid = validator ? validator(value) : true
            if (isValid) {
                setError("")
            } else {
                setError(errorText || `${title} is invalid`)
            }
            return {
                isValid,
                value,
            }
        },
        resetValues: () => {
            setValue("")
            setError("")
        }
    }))

    return (
        <div className="my-2">
            <label className="block text-sm font-medium text-gray-700">{title}</label>

            <textarea
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={disabled}
                placeholder={placeholder}
                rows={2}
                className={`mt-1 mb-2 block w-full rounded-md border border-gray-400 bg-white shadow-sm px-3 py-2
                focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                resize-none transition-colors duration-150
                ${error ? "border-red-500" : "border-gray-400"}`}
            />
            {error && (
                <p className="mt-1 text-sm text-red-600">
                    {error}
                </p>
            )}
        </div>
    )
})

export default TextAreaInput
